
const $jsAPI = {};

$jsAPI.callFunction = function (apiFunctionName, params = [], defaultValue = null) {

  if (!window.$JBoardAPI || !window.$JBoardAPI.hasOwnProperty(apiFunctionName)) {
    return defaultValue;
  }

  if (!window.$jBoard.config.enable_api) {
    return defaultValue;
  }

  try{
    return window.$JBoardAPI[apiFunctionName].apply(null, params);
  } catch (err) {
    console.log('$jBoard.' + apiFunctionName + ' function threw an error, the call to the function will be ignored.');
    console.error(err);

    return defaultValue;
  }

};

$jsAPI.fireEvent = function(eventName,  ...args) {

  if (window.$inBuilderMode || window.$jBoardEvents === undefined || window.$actingVisitorIsBot) {
    return;
  }

  let handlers = window.$jBoardEvents
                  .filter(listener => listener[0] === eventName)
                  .map(handler => handler[1]);

  handlers.forEach(handler => {
    if (typeof handler === 'function') {
      try{
        handler( ...args)
      } catch (e) {
        console.error('An error occurred inside "' + eventName + '" event handler: ', e);
        console.error('Event Params', args);
      }
    }
  })

}

Object.freeze($jsAPI);

export default $jsAPI;
